import { render, staticRenderFns } from "./SnackBarVT.vue?vue&type=template&id=0655878e&scoped=true"
import script from "./SnackBarVT.vue?vue&type=script&lang=js"
export * from "./SnackBarVT.vue?vue&type=script&lang=js"
import style0 from "./SnackBarVT.vue?vue&type=style&index=0&id=0655878e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655878e",
  null
  
)

export default component.exports